<template>
  <BbBtn
    size="large"
    type="secondary"
    :class="{ selected: isSelected }"
    @click="$emit('set-filter-value')"
    :is-disabled="disabled"
  >
    <BbIcon v-if="withCheckIcon && isSelected" size="small" name="checkmark-small" />
    {{ label }}
    <BbIcon v-if="withClearIcon && isSelected" size="small" name="x-small" @click="onClear" />
  </BbBtn>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    withCheckIcon: {
      type: Boolean,
      default: false,
    },
    withClearIcon: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['set-filter-value', 'on-clear'],
  setup(props, { emit }) {
    const onClear = (event) => {
      event.stopPropagation();
      emit('on-clear');
    };

    return {
      onClear,
    };
  },
};
</script>

<style scoped lang="scss">
.selected {
  border: 4px solid $bb-primary-3 !important;
  background: $bb-interface-11 !important;

  :deep(.v-btn__content) {
    color: #6222e3;
  }

  &:hover {
    border: 4px solid $bb-primary-3 !important;
    background: $bb-interface-11 !important;
  }
}

.bb-btn.secondary {
  border-radius: 4px !important;
  border: 1px solid $bb-neutral-3 !important;
  padding: 16px 24px !important;
  display: flex;
  align-items: center;
  height: 54px !important;

  &:hover {
    border: 1px solid $bb-neutral-1 !important;
    background: transparent !important;
  }

  :deep(.v-btn__content) {
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    display: flex;
    gap: $bb-spacing-2;
  }
}

.bb-btn.secondary.v-btn--disabled {
  border: 1px solid $bb-neutral-4 !important;

  :deep(.v-btn__content) {
    color: $bb-neutral-4;
  }
}
</style>
